module.exports = __webpack_public_path__ + "img/sns_kakao_symbol.7c1dcf5c.svg";